module.exports = __webpack_public_path__ + "assets/img/zenlayer@2x.81c18a9e.png";